import { useState, useEffect } from "react";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { debounce } from "lodash";
import { useToast } from "../../Utils/toastContext";
import { useNavigate, useLocation } from "react-router-dom";
import RiskAssessmentQuestionManagementTrigger from "../../Pages/Risk-Assessment/risk-assessment-trigger";

export default function EDDModal({ closeModal, pendingQuestions, completedQuestions}) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [options, setOptions] = useState([{}]);
  const [question, setQuestion] = useState("");
  const [questionType, setQuestionType] = useState(1);
  const [questionTypeLabel, setQuestionTypeLabel] = useState("Text");
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [required, setRequired] = useState(false);
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 font-mediuum">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="bg-white h-[90vh]  rounded-lg shadow-lg overflow-y-auto">
        <RiskAssessmentQuestionManagementTrigger  closeModal={closeModal} pendingQuestions={pendingQuestions} completedQuestions={completedQuestions} />
      </div>
    </div>
  );
}